import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Center } from '@mantine/core';
import Tilt from 'react-parallax-tilt';
import { Progress } from '@mantine/core';

const RewardProgress = (props) => {
    const dispatch = useDispatch();

    const epoch = useSelector(state => state.mainapp.stakingSlice.epoch)
    const stakingEarnedAmount = useSelector((state) => state.mainapp.stakingSlice.earnings)
    const stakedAt = useSelector((state) => state.mainapp.stakingSlice.stakingTime)
    const userIndex = useSelector((state) => state.mainapp.stakingSlice.userIndex)

    // Ensuring markerPosition is always within the range of 0 to 100
    const markerPosition = ((userIndex + 1) / epoch.size) * 100;
    const validMarkerPosition = Math.min(100, Math.max(0, markerPosition));
    const barSize = ((epoch.index + 1) / epoch.size) * 100;
    const validBarSize = epoch.start ? Math.min(100, Math.max(0, barSize)) : 0;
    const markerText = useMemo(() => {
        if (epoch.index === userIndex) {
            return 'Your turn';
        } else if (epoch.index > userIndex) {
            return 'Rewards Received';
        } else {
            return 'Upcoming Turn';
        }
    }, [epoch]);
    const stakeholderNotWaitList = useSelector(state => state.mainapp.stakingSlice.stakeholderNotWaitList)


    return (
        <>
            {
                stakeholderNotWaitList ? <div className='seat-text'>
                    <p>Your Seat <span>
                        {userIndex + 1}
                    </span></p>
                </div> : null
            }
            <div className='reward-progress'>
                <div className='reward-progress-title'>
                    <i className='material-icons'>stars</i>
                    <div className='reward-progress-counter'>
                        <h2>{`${epoch.index + 1} of ${epoch.size}`}</h2>
                        <p>Current Position</p>
                    </div>
                </div>

                <div className='reward-progress-bar' style={{ position: 'relative' }}>
                    <Progress color='#12B1FF' radius="xl" size="xl" value={validBarSize} />
                    {
                        stakeholderNotWaitList ? <><div className='progress-marker-text' style={{ left: `calc(${validMarkerPosition}% - 36px)` }}>
                            {markerText}
                        </div>
                            <div className='progress-marker' style={{ left: `${validMarkerPosition}%` }}></div> </> : null
                    }
                </div>
            </div>
        </>
    );
};

export default RewardProgress
